
import { Header } from '../components/Header';
import {Footer} from '../components/Footer';
import { CircleCheckBig } from "lucide-react";
import { CookieBanner } from '../components/Cookies';


const Home = () => {
	return (
		<div className='home'>
			<Header></Header>
			<div class='card text-bg-dark'>
				<img
					src='https://images.unsplash.com/photo-1742069028875-93c524b6fa95?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjYXIlMjB0b3dpbmclMjB0cnVja3xlbnwxfHx8fDE3NjE2NDAxMDl8MA&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080&amp;utm_source=figma&amp;utm_medium=referral'
					class='card-img'
					alt='Dépanneuse auto'
					style={{ maxHeight: '500px' }}
				/>
				<div class='card-img-overlay text-bg-dark bg-opacity-75'>
					<h2 class='mx-5'>
						<span class='badge text-bg-danger'>Votre partenaire multi-services</span>
					</h2>
					<br />
					<h1 class='mx-5'>
						Dépannage, Épaviste &<br /> Débarras <span style={{ color: '#fd0000' }}>64 • 40</span>
					</h1>{' '}
					<br />
					<p class='mx-5'>
						Dépannage auto/moto 24h/24, enlèvement d'épaves gratuit, évacuation d'encombrants et vide maison.
						<br />
						Intervention rapide dans le Pays Basque, le Béarn et les Landes.
					</p>{' '}
					<br />
					<button type='button' class='btn btn-danger mx-5'>
						<a href='tel:0618767935' style={{ color: '#fdfcfc', textDecoration: 'none' }}>
							Appelez maintenant
						</a>
					</button>
					<br />
					<div class='container'>
						<br />
						<div class='row'>
							<div class='col'>
								<CircleCheckBig color='#239f38' size={28} /> Dépannage 24/7
							</div>
							<div class='col'>
								<CircleCheckBig color='#239f38' size={28} /> Épaviste agréé
							</div>
							<div class='col'>
								<CircleCheckBig color='#239f38' size={28} /> Vide maison
							</div>
							<div class='col'>
								<CircleCheckBig color='#239f38' size={28} /> Tarifs compétitifs
							</div>
						</div>
					</div>
				</div>
			</div>
			<CookieBanner></CookieBanner>
			<Footer></Footer>
		</div>
	);
};

export default Home;
